<template>
  <table class="ui striped basic table printable">
    <TicketModal ref="ticketModal" />
    <div v-show="loading" class="ui active inverted dimmer">
      <div class="ui text loader">Carregando...</div>
    </div>
    <thead>
      <tr>
        <th colspan="7" class="action-row">
          <div class="ui grid">
            <div class="row">
              <div class="four wide column">
                <router-link
                  class="new-record"
                  :to="`/contracts/${contract.id}/invoices/new`"
                >
                  <i class="plus icon"></i>Nova parcela
                </router-link>
              </div>
              <div class="right aligned twelve wide column">
                <div class="actions">
                  <a @click.prevent="refresh()">
                    <i class="refresh icon"></i>Atualizar
                  </a>
                </div>
              </div>
            </div>
          </div>
        </th>
      </tr>
      <tr>
        <th></th>
        <th class="center aligned"></th>
        <th class="center aligned">Número</th>
        <th class="center aligned">Competência</th>
        <th>Vencimento</th>
        <th>Pagamento</th>
        <th>Valor</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(invoice, index) in invoices" :key="index">
        <td class="one wide center aligned">
          <!-- paid -->
          <span
            v-if="invoice.paid"
            class="ui green empty circular label"
            title="Parcela paga"
          ></span>

          <!-- late -->
          <span
            v-else-if="invoice.late"
            class="ui red empty circular label"
            title="Parcela atrasada"
          ></span>

          <!-- unpaid -->
          <span
            v-else
            class="ui orange empty circular label"
            title="Parcela em aberto"
          ></span>
        </td>
        <td class="actions">
          <router-link
            :to="`/contracts/${invoice.contract_id}/invoices/${invoice.id}`"
          >
            <i class="edit icon"></i> Editar
          </router-link>
          <a v-if="ticketEnabled" @click.prevent="openTicketModal(invoice)">
            Boleto
          </a>
        </td>
        <td class="center aligned">{{ invoice.number | sequence }}</td>
        <td class="center aligned">{{ invoice.competence }}</td>
        <td>{{ invoice.due_date | date }}</td>
        <td>{{ invoice.date_of_payment | date }}</td>
        <td>{{ invoice.amount | money }}</td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import exportCSV from '@/utils/exportCSV';
import printTable from '@/utils/printTable';
import TicketModal from './ticket_modal';

export default {
  components: { TicketModal },
  data() {
    return {
      loading: false,
      invoices: [],
      contract: {},
      selected: []
    };
  },

  mounted() {
    $('.ui.checkbox').checkbox();
  },

  computed: {
    ticketEnabled() {
      return (
        this.$store.state.settings.settings.payment_boleto_gateway_provider !=
          null && this.contract.payment_method_ticket
      );
    }
  },

  methods: {
    openTicketModal(invoice) {
      this.$refs.ticketModal.open(invoice, this.contract);
    },

    refresh() {
      this.$emit('refresh');
    },

    toggleLoading() {
      this.loading = !this.loading;
    },

    print() {
      const { headers, data } = this.getHeadersAndData();
      printTable(headers, data);
    },

    toCSV() {
      const { headers, data } = this.getHeadersAndData();
      exportCSV(headers, data, `${this.resource}`);
    },

    setData(invoices, contract) {
      this.invoices = _.clone(invoices);
      this.contract = _.clone(contract);
    }
  }
};
</script>
<style lang="css" scoped>
.actions a {
  padding: 0px 10px;
}
</style>
